<template>
  <section class="inicio-usuario" :style="estiloEvento">
    <!-- 🔥 HEADER EVENTO -->
    <div v-if="evento">
      <header class="hero-evento">
        <h1 :style="{ color: eventoTexto + ' !important' }">{{ evento.nombre }}</h1>
        <p class="rango-fecha" :style="{ color: eventoTexto + ' !important' }">{{ rangoFechas }}</p>
      </header>

      <!-- 🔎 BUSCADOR -->
      <div class="buscador">
        <span class="icon-search">🔍</span>
        <input
          v-model.trim="filtroBusqueda"
          type="text"
          :placeholder="placeholderBusqueda"
          @keyup.enter="buscar"
        />
        <button class="btn-reglas" @click="verReglas">
          <span class="mdi mdi-file-document-box mdi-24px mr-2"></span>
          Términos y condiciones
        </button>
      </div>

      <!-- ⭐ CHIPS DE CIUDAD -->
      <div class="chips scroll-x">
        <span
          v-for="c in chipsCiudades"
          :key="c.id"
          :class="['chip', { activo: c.id === chipCiudadActiva }]"
          @click="chipCiudadActiva = c.id"
        >
          {{ c.label }}
        </span>
      </div>

      <!-- 🍔 GRID RESTAURANTES -->
      <div v-if="chipActivo === 'restaurantes'">
        <h2 class="subtitulo">Restaurantes Participantes</h2>
        <div class="grid-productos">
          <div
            v-for="rest in restaurantesFiltrados"
            :key="rest.id"
            class="card-producto"
            @click="irARestaurante(rest.id)"
          >
            <img :src="rest.logo" :alt="rest.nombre" />
            <div class="card-caption">
              {{ rest.nombre }}
            </div>
          </div>
        </div>
      </div>

      <!-- 🍔 GRID PRODUCTOS -->
      <div v-else-if="chipActivo === 'productos'">
        <h2 class="subtitulo">Productos</h2>
        <div class="grid-productos">
          <div
            v-for="foto in fotosFiltradas"
            :key="foto.id"
            class="card-producto"
            @click="irAProducto(foto.producto_id)"
          >
            <img :src="foto.url" :alt="foto.nombre_producto" />
            <div class="overlay">{{ foto.nombre_producto }}</div>
          </div>
        </div>
      </div>

      <!-- 🎮 JUEGO -->
      <div v-else-if="chipActivo === 'juego'" class="placeholder">
        Próximamente
      </div>

      <!-- ⭐ PERFIL USUARIO -->
      <div v-else-if="chipActivo === 'calificaciones'">
        <perfil-usuario :color="eventoColor" />
      </div>
    </div>

    <!-- 🚫 NO HAY EVENTO -->
    <div v-else class="no-evento-screen">
      <div class="no-evento-content animate__animated animate__fadeIn">
        <div class="brand-icon">✦</div>
        <h2>No hay eventos activos</h2>
        <p class="no-evento-sub">Mantente al tanto de nuestros próximos eventos</p>
        <div class="instagram-cta">
          <a href="https://instagram.com/metropolitan.food" target="_blank" rel="noopener" class="ig-link">
            <span class="mdi mdi-instagram mdi-24px"></span>
            <span>Síguenos en Instagram</span>
          </a>
          <p class="ig-handle">@metropolitan.food</p>
        </div>
      </div>
    </div>

    <!-- 🚀 TAB-BAR INFERIOR (Solo si hay evento) -->
    <nav class="tabbar" :style="tabbarStyle" v-if="evento">
      <button
        v-for="tab in tabs"
        :key="tab.id"
        :class="['tab', { activo: tab.id === chipActivo }]"
        @click="selectChip(tab.id)"
        :style="{ color: tab.id === chipActivo ? eventoColor : eventoTexto }"
      >
        <b-icon :icon="tab.icon" size="is-medium" />
        <span class="label" :style="{ color: eventoTexto }">
          {{ tab.label }}
        </span>
      </button>
    </nav>


    <!-- CARGADOR FULL-PAGE -->
    <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false" />
  </section>
</template>

<script>
import HttpService from "../Servicios/HttpService";
import Swal from "sweetalert2";
import { ColorContrasteMixin } from "./mixins/ColorContrasteMixin";
import { ProductAccessMixin } from "./mixins/ProductAccessMixin";
import PerfilUsuario from "./PerfilUsuario.vue";
import {
  guardarDatosSesion,
  obtenerDatosSesion,
} from "@/utils/sesionCalificacion";

export default {
  name: "inicio-usuario",
  mixins: [ColorContrasteMixin, ProductAccessMixin],
  components: { PerfilUsuario },

  data() {
    return {
      evento: null,
      restaurantes: [],
      fotos: [],
      cargando: false,
      filtroBusqueda: "",
      chipActivo: "restaurantes",
      calificaciones: [],
      chipsCiudades: [],
      chipCiudadActiva: "todas",
      terminos: "",
      tabs: [
        { id: "restaurantes", label: "Restaurantes", icon: "home-outline" },
        { id: "productos", label: "Productos", icon: "food" },
        { id: "juego", label: "Juega", icon: "crown" },
        { id: "calificaciones", label: "Mi perfil", icon: "account" },
      ],
    };
  },

  mounted() {
    this.cargarAjustes();
    this.obtenerEvento();
  },

  methods: {
    cargarAjustes() {
      HttpService.registrar('ajustes.php', { accion: 'obtener' })
        .then(res => {
          if (res) {
             this.terminos = res.terminos || '';
          }
        });
    },

    normalizarCiudad(txt) {
      // si viene null, undefined o '', devuelve ''
      return (txt || "").toString().trim().toLowerCase().replace(/\s+/g, "_");
    },

    /* …resto de métodos… */

    /* Utils */
    hexToRgba(hex, alpha = 1) {
      const bigint = parseInt(hex.replace("#", ""), 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      return `rgba(${r},${g},${b},${alpha})`;
    },

    formatearFecha(iso) {
      if (!iso) return "";
      const opciones = { weekday: "long", day: "2-digit", month: "long" };
      const fecha = new Date(`${iso}T00:00:00`);
      const texto = fecha
        .toLocaleDateString("es-ES", opciones)
        .replace(",", "");
      return texto.charAt(0).toUpperCase() + texto.slice(1);
    },

    /* API */
    obtenerEvento() {
      this.cargando = true;
      HttpService.registrar("eventos.php", { accion: "obtener" }).then(
        (res) => {
          if (Array.isArray(res) && res.length) {
            // SOLO mostrar eventos con bandera activo == 1
            const activo = res.find(e => e.activo == 1);
            if (activo) {
              this.evento = activo;
              // Solo cargar contenido si hay evento activo
              this.obtenerRestaurantes();
              this.cargarFotos();
              const sesion = obtenerDatosSesion();
              if (sesion?.telefono) this.obtenerCalificaciones(sesion.telefono);
            } else {
              this.evento = null;
            }
          } else {
            this.evento = null;
          }
          this.cargando = false;
        }
      ).catch(() => {
        this.evento = null;
        this.cargando = false;
      });
    },

    obtenerRestaurantes() {
      HttpService.registrar("restaurantes.php", { 
        accion: "obtener",
        id_evento: this.evento ? this.evento.id : null
      }).then(
        (res) => {
          this.restaurantes = (res || []).sort(() => 0.5 - Math.random());
          const set = new Set(
            this.restaurantes
              .flatMap((r) => [r.ciudad, r.ciudad2])
              .map((c) => c?.trim())
              .filter(Boolean)
          );
          this.chipsCiudades = ["Todas", ...set].map((txt) => ({
            id: txt.toLowerCase().replace(/\s+/g, "_"),
            label: txt,
          }));
        }
      );
    },

    cargarFotos() {
      this.cargando = true;
      HttpService.registrar("productos.php", { 
        accion: "obtener_fotos",
        id_evento: this.evento ? this.evento.id : null
      }).then(
        (res) => {
          const todas = res || [];
          // 👇 fuerza a number para que case con restaurantes.id
          this.fotos = todas
            .filter((f) => f.posicion == 1)
            .map((f) => ({ ...f, restaurante_id: Number(f.restaurante_id) }))
            .sort(() => 0.5 - Math.random());

          this.cargando = false;
        }
      );
    },

    obtenerCalificaciones(idUsuario) {
      HttpService.registrar("calificaciones.php", {
        accion: "obtener_usuario_todas",
        idParticipante: idUsuario,
      }).then((res) => (this.calificaciones = res || []));
    },

    /* Navegación */
    irAProducto(id) {
      if (!this.productsAreAvailable()) {
        this.showProductAlert();
        return;
      }
      this.$router.push({ name: "InfoProducto", params: { id } });
    },
    irARestaurante(id) {
      this.$router.push({ name: "InfoRestaurante", params: { id } });
    },
    buscar() {},

    verReglas() {
      const htmlContent = this.terminos 
        ? `<div style="max-height:60vh; overflow-y:auto; text-align:left; line-height:1.5; white-space: pre-wrap;">${this.terminos}</div>`
        : `<p>No hay términos y condiciones definidos.</p>`;

      Swal.fire({
        title: "Términos y condiciones",
        html: htmlContent,
        confirmButtonColor: "#3273dc",
        background: "rgba(35,45,53,0.95)",
        color: "#fff",
        customClass: {
          popup: "swal-dark",
        },
      });
    },

    async solicitarDatosSesion() {
      const actual = obtenerDatosSesion();
      if (actual?.telefono && actual?.nombre) return actual;

      const { value, isConfirmed } = await Swal.fire({
        title: "Datos para participar",
        html: `
          <input id="numeroTelefono" class="swal2-input" placeholder="Número de teléfono" value="${
            actual?.telefono || ""
          }" />
          <input id="nombreCalificador" class="swal2-input" placeholder="Nombre de quien califica" value="${
            actual?.nombre || ""
          }" />
        `,
        confirmButtonText: "Guardar",
        focusConfirm: false,
        preConfirm: () => {
          const telefono = document
            .getElementById("numeroTelefono")
            .value.trim();
          const nombre = document
            .getElementById("nombreCalificador")
            .value.trim();
          if (!telefono || !nombre) {
            Swal.showValidationMessage("Completa todos los campos");
            return false;
          }
          return { telefono, nombre };
        },
      });

      if (!isConfirmed || !value) return null;
      const datos = guardarDatosSesion(value);
      if (datos?.telefono) this.obtenerCalificaciones(datos.telefono);
      return datos;
    },

    async selectChip(id) {
      if (id === "juego") {
        this.$router.push({ name: "JugadoresComponente" });
        return;
      }

      if (id === "productos" && !this.productsAreAvailable()) {
        this.showProductAlert();
        return;
      }

      if (id === "calificaciones") {
        const sesion = await this.solicitarDatosSesion();
        if (sesion?.telefono) {
          this.obtenerCalificaciones(sesion.telefono);
          this.chipActivo = id;
        }
        return;
      }

      this.chipActivo = id;
    },
  },

  computed: {
    rangoFechas() {
      return `${this.formatearFecha(
        this.evento.fecha_inicio
      )} – ${this.formatearFecha(this.evento.fecha_fin)}`;
    },
    estiloEvento() {
      const color = this.evento ? this.evento.color_principal : "#fff";
      return { backgroundColor: color, color: this.colorContraste(color) };
    },
    placeholderBusqueda() {
      return this.chipActivo === "productos"
        ? "Nombre del producto"
        : "Nombre del restaurante";
    },
    fotosFiltradas() {
      let lista = this.fotos;

      /* ➡️ FILTRO POR CIUDAD */
      if (this.chipCiudadActiva !== "todas") {
        const idsCiudad = this.restaurantes
          .filter((r) =>
            [r.ciudad, r.ciudad2]
              .map(this.normalizarCiudad)
              .includes(this.chipCiudadActiva)
          )
          .map((r) => r.id);

        lista = lista.filter((f) => idsCiudad.includes(f.restaurante_id));
      }

      /* ➡️ FILTRO DE BÚSQUEDA */
      if (this.filtroBusqueda) {
        const fil = this.filtroBusqueda.toLowerCase();
        lista = lista.filter((f) =>
          f.nombre_producto.toLowerCase().includes(fil)
        );
      }
      return lista;
    },
    restaurantesFiltrados() {
      let lista = this.restaurantes;

      if (this.chipCiudadActiva !== "todas") {
        lista = lista.filter((r) =>
          [r.ciudad, r.ciudad2]
            .map(this.normalizarCiudad)
            .includes(this.chipCiudadActiva)
        );
      }

      if (this.filtroBusqueda) {
        const fil = this.filtroBusqueda.toLowerCase();
        lista = lista.filter((r) => r.nombre.toLowerCase().includes(fil));
      }
      return lista;
    },
    /* Colores dinámicos */
    eventoColor() {
      return this.evento?.color_principal || "#1e293b";
    },
    eventoTexto() {
      return this.colorContraste(this.eventoColor);
    },
    tabbarStyle() {
      return {
        background: this.hexToRgba(this.eventoColor, 0.82),
        backdropFilter: "blur(12px)",
      };
    },
  },
};
</script>

<style scoped>
/* -------- BASE -------- */
.inicio-usuario {
  padding: 20px;
  min-height: 100vh;
  padding-bottom: 80px; /* espacio para tab-bar */
}

.aviso-finalizado {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 12px;
  padding: 0.9rem 1rem;
  margin-bottom: 1rem;
  color: inherit;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.12);
}

.aviso-finalizado strong {
  display: block;
  margin-bottom: 0.25rem;
  font-size: 1rem;
}

/* -------- NO EVENTO -------- */


/* -------- HEADER EVENTO -------- */
.hero-evento {
  text-align: center;
  margin-bottom: 1.2rem;
}
.hero-evento h1 {
  font-size: 2rem;
  font-weight: 700;
}
.hero-evento .rango-fecha {
  font-size: 0.9rem;
  opacity: 0.8;
}

/* -------- BUSCADOR -------- */
.buscador {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(0, 0, 0, 0.25);
  padding: 0.6rem 0.8rem;
  border-radius: 12px;
  margin-bottom: 1rem;
}
.buscador input {
  flex: 1;
  border: none;
  background: transparent;
  color: inherit;
  outline: none;
}
.icon-search {
  opacity: 0.6;
}
.btn-reglas {
  /* degradado de negro semitransparente (arriba más claro, abajo más oscuro) */
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.3),
    rgba(67, 176, 240, 0.534)
  );
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.35rem 0.65rem;
  font-size: 0.75rem;
  cursor: pointer;

  /* opcional: si quieres efecto vidrio */
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}
/* color azul para la X de cerrar */
.swal2-close {
  color: #3273dc !important;
}

/* -------- CHIPS CIUDAD -------- */
.scroll-x {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.chips {
  display: flex;
  gap: 0.6rem;
  margin-bottom: 1.2rem;
}
.chip {
  flex: 0 0 auto;
  padding: 0.45rem 1rem;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 9999px;
  font-size: 0.85rem;
  cursor: pointer;
  white-space: nowrap;
  color: var(--c-texto, #fff);
}
.chip.activo {
  background: var(--c-evento, #2c73d2);
}

/* -------- GRID PRODUCTOS -------- */
.subtitulo {
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 0.8rem;
}
.grid-productos {
  display: grid;
  gap: 1rem;
  /* Siempre al menos 2 columnas de igual ancho */
  grid-template-columns: repeat(2, 1fr);
}

@media (min-width: 480px) {
  .grid-productos {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
}
.card-producto {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  opacity: 0;
  transform: translateY(10px);
  animation: fadeIn 0.4s forwards ease;
  transition: transform 0.2s, box-shadow 0.2s;
}
.card-producto:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}
.card-producto img {
  width: 100%;
  height: 170px;
  object-fit: cover;
}
.card-producto .overlay {
  position: absolute;
  left: 8px; /* 👈 ahora se ve */
  bottom: 8px; /* 👈 ahora se ve */

  display: inline-block; /* mide solo el texto */
  max-width: calc(100% - 16px);
  padding: 2px 6px; /* aire interno */

  background: rgba(0, 0, 0, 0.38);
  backdrop-filter: blur(3px);
  font-size: 0.9rem;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
  transition: background 0.25s ease, transform 0.25s ease;
}

/* efecto hover en desktop */
.card-producto:hover .overlay {
  background: rgba(0, 0, 0, 0.6);
  transform: translateY(-2px);
}

/* keep the mobile block tal cual */
@media (hover: none) and (pointer: coarse) {
  .card-producto .overlay {
    left: 0;
    bottom: 0;
    width: 100%;
    border-radius: 0 0 8px 8px;
    padding: 4px 8px;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0));
    transform: none !important;
  }
}

.card-producto {
  position: relative; /* asegura el contexto */
}
.card-producto:hover .overlay {
  background: rgba(0, 0, 0, 0.6);
  transform: translateY(-2px);
}
.card-caption {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
  color: #fff;
  padding: 0.5rem;
  font-weight: bold;
  text-align: center;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@keyframes fadeIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* -------- PLACEHOLDER & LISTAS -------- */
.placeholder {
  text-align: center;
  padding: 2rem 0;
}

/* -------- TAB-BAR -------- */
.tabbar {
  position: fixed;
  inset: auto 0 0 0;
  height: 64px;
  display: flex;
  justify-content: space-around;
  backdrop-filter: blur(12px);
  background: rgba(30, 41, 59, 0.82);
  border-top: 1px solid rgba(255, 255, 255, 0.07);
  z-index: 999;
  bottom: 24px;
}
.tab {
  flex: 1 1 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding-top: 4px;
  background: none;
  border: none;
  font-size: 0.75rem;
  cursor: pointer;
}
.tab b-icon {
  font-size: 1.5rem;
  line-height: 1;
  transition: opacity 0.25s ease;
}
.tab:not(.activo) {
  color: var(--c-texto, #fff);
  opacity: 0.75;
}
.tab.activo {
  color: var(--c-evento, #797a2c);
}
.tab.activo b-icon {
  opacity: 1;
}
@import url('https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap');

.popup-retro {
  border: 2px solid #10b981;
  border-radius: 16px;
  padding: 20px;
  font-family: 'Press Start 2P', monospace !important;
}

.btn-retro-confirm {
  background-color: #10b981 !important;
  color: #fff !important;
  font-family: 'Press Start 2P', monospace !important;
  font-size: 11px !important;
  padding: 10px 14px !important;
  border: none;
  border-radius: 6px;
  box-shadow: 0 0 6px #10b981;
}

.btn-retro-deny {
  background-color: #3b82f6 !important;
  color: #fff !important;
  font-family: 'Press Start 2P', monospace !important;
  font-size: 11px !important;
  padding: 10px 14px !important;
  border: none;
  border-radius: 6px;
  box-shadow: 0 0 6px #3b82f6;
}

.btn-retro-cancel {
  background-color: #6b7280 !important;
  color: #fff !important;
  font-family: 'Press Start 2P', monospace !important;
  font-size: 11px !important;
  padding: 10px 14px !important;
  border: none;
  border-radius: 6px;
}

/* ── No-Event Screen ── */
.no-evento-screen {
  position: fixed;
  inset: 0;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.no-evento-content {
  text-align: center;
  padding: 40px;
  max-width: 420px;
}

.brand-icon {
  font-size: 3rem;
  color: #fff;
  margin-bottom: 1.5rem;
  opacity: 0.6;
  letter-spacing: 4px;
}

.no-evento-content h2 {
  font-family: 'Poppins', sans-serif;
  font-size: 1.6rem;
  font-weight: 600;
  color: #fff;
  margin-bottom: 0.75rem;
  letter-spacing: 0.5px;
}

.no-evento-sub {
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.95rem;
  line-height: 1.6;
  margin-bottom: 2.5rem;
}

.instagram-cta {
  margin-top: 1rem;
}

.ig-link {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 14px 32px;
  background: linear-gradient(135deg, #833ab4, #fd1d1d, #fcb045);
  color: #fff !important;
  font-weight: 600;
  font-size: 0.95rem;
  border-radius: 50px;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(131, 58, 180, 0.4);
}

.ig-link:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 28px rgba(131, 58, 180, 0.5);
}

.ig-handle {
  color: rgba(255, 255, 255, 0.35);
  font-size: 0.85rem;
  margin-top: 1rem;
  letter-spacing: 1px;
}

</style>
